import { Component, Input, OnInit, ChangeDetectionStrategy, ElementRef, inject } from '@angular/core';
import { BreakpointService } from 'src/app/services/breakpoint.service';
import { NavigationEnd, Router, RouterLink, RouterOutlet } from '@angular/router';
import { filter, map } from 'rxjs/operators';
import { TranslatePipe } from '@ngx-translate/core';
import { Title } from '@angular/platform-browser';
import { MatTabsModule } from '@angular/material/tabs';
import { AngularSvgIconModule } from 'angular-svg-icon';
import { MatToolbarModule } from '@angular/material/toolbar';
import { NgClass } from '@angular/common';

export type Breadcrumb = { link: string; label: string };

@Component({
  selector: 'app-info-page',
  templateUrl: './info-page.component.html',
  styleUrls: ['./info-page.component.scss'],
  providers: [TranslatePipe],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [TranslatePipe, NgClass, MatToolbarModule, RouterLink, AngularSvgIconModule, MatTabsModule, RouterOutlet],
})
export class InfoPageComponent implements OnInit {
  @Input() set title(data: string) {
    if (data) {
      this._title = data;
      if (this.activeLink) {
        const prefixTabTitle = this.activeLink.charAt(0).toUpperCase() + this.activeLink.slice(1);
        this.titleService.setTitle(
          `${this.title ? this.title : ''} - ${prefixTabTitle} - ${
            this.isComponentOrProject === 'PROJECT' ? 'Project' : 'Component'
          }`
        );
      }
    }
  }

  get title(): string {
    return this._title;
  }
  _title = '';
  @Input() isComponentOrProject?: 'PROJECT' | 'COMPONENT';
  @Input() links: { id: string; label: string; path: string }[] = [];
  @Input() showNav = true;
  @Input() hasBorderBottom = false;

  @Input() breadcrumbs: Breadcrumb[] = [];
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  activeLink: string | undefined;

  private readonly host = inject<ElementRef<HTMLElement>>(ElementRef);
  private readonly bp = inject(BreakpointService);

  constructor(private router: Router, private titleService: Title) {
    router.events
      .pipe(
        filter((event): event is NavigationEnd => event instanceof NavigationEnd),
        map((navigationEnd) => navigationEnd.urlAfterRedirects)
      )
      .subscribe((url: string) => {
        this.activeLink = url.split('?')[0].split('/').pop();
        this.revealActiveTab();
      });
  }

  /** Phones scroll the tab strip by swiping; bring the current tab into view after a route change. */
  private revealActiveTab(): void {
    if (!this.bp.isPhone()) return;
    // The router marks the new tab active a tick after NavigationEnd.
    setTimeout(() => {
      const root = this.host.nativeElement;
      const strip = root.querySelector<HTMLElement>('.mat-mdc-tab-link-container');
      const tab = root.querySelector<HTMLElement>('.mat-mdc-tab-link.mdc-tab--active');
      if (!strip || !tab) return;
      strip.scrollTo({ left: tab.offsetLeft - (strip.clientWidth - tab.offsetWidth) / 2, behavior: 'smooth' });
    }, 100);
  }

  setTabTitle(id: string): void {
    this.activeLink = id;
    const prefixTabTitle = this.activeLink.charAt(0).toUpperCase() + this.activeLink.slice(1);
    this.titleService.setTitle(
      `${this.title ? this.title : ''} - ${prefixTabTitle} - ${
        this.isComponentOrProject === 'PROJECT' ? 'Project' : 'Component'
      }`
    );
  }

  clickNav(): void {
    void this.router.navigate(['/components']);
  }
  ngOnInit(): void {}
}
